import { useTranslation } from 'react-i18next'
import { Mode } from '@ocean/types/dist/appearance'
import { expanders } from '@ocean/ui'
import { namespace } from 'modules/Auth/localization'
import { Wrapper, Title } from './PreMaintenanceMessage.styled'

const { Expander } = expanders

const I18_PATH = `${namespace}:auth.maintenance`

type PreMaintenanceMessageProps = {
  text?: Nullable<string>
}

const PreMaintenanceMessage: React.FC<PreMaintenanceMessageProps> = ({ text }) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Title data-test='PreMaintenanceMessageTitle'>{t(`${I18_PATH}.plannedTitle`)}</Title>
      {text && (
        <Expander
          rows={3}
          text={text}
          mode={Mode.Gold}
          typography={null}
          dataTest='PreMaintenanceMessage'
        />
      )}
    </Wrapper>
  )
}

export default PreMaintenanceMessage
